
import { mapGetters } from 'vuex'
import { getBaseUrl } from '~/config/api'
import { api } from '~/config/api.js'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import TextInput from '~/components/Registration/input/index.vue'
import AddressInput from '~/components/Registration/input/address.vue'
import { checkAddressesEqual } from '~/ZenOne-StoryBook/helpers/maps'
import DialogPaymentInfo from '~/components/dialog/dialog-payment-info/index.vue'

export default {
  name: 'RegistrationStepThree',
  components: {
    DialogPaymentInfo,
    AddressInput,
    TextInput
  },
  mixins: [ui],
  props: {},
  data() {
    return {
      selectedSpecialties: [],
      specialties: ['General Practice', 'Pediatric', 'Oral Surgery', 'Orthodontics', 'Periodontics', 'Endodontics'],
      practiceName: '',
      validPracticeName: false,
      phone: '',
      validPhone: false,
      shippingAddress: {},
      validShippingAddress: false,
      shippingSuite: '',
      billingIsSame: true,
      billingAddress: {},
      validBillingAddress: false,
      billingSuite: '',
      externalError: '',
      ready: false,
      paymentMethodDialog: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      card: 'user/card',
    }),
    valid() {
      return this.validPracticeName && this.validPhone && this.validShippingAddress && (this.billingIsSame || this.validBillingAddress) && this.ccNumber
    },
    ccNumber() {
      return this.card?.number
    }
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit('validation', v)
      },
      immediate: true
    }
  },
  async created() {
    await this.$store.dispatch('user/SetUserPracticeLocation')

    this.practiceName = this.user.practiceLocation.name
    this.shippingAddress = this.normalize(this.user.practiceLocation.address)
    this.shippingSuite = this.normalize(this.user.practiceLocation.address?.unit)
    this.billingAddress = this.normalize(this.user.practiceLocation.billingAddress)
    this.billingSuite = this.normalize(this.user.practiceLocation.billingAddress?.unit)
    this.selectedSpecialties = [...this.user.practiceLocation.params?.specialties ?? []]
    this.phone = this.user.practiceLocation.params?.phone
    this.billingIsSame = this.shippingAddress?.city ? checkAddressesEqual(this.shippingAddress, this.billingAddress) : true

    this.ready = true
  },
  methods: {
    normalize(data) {
      return Array.isArray(data) && data.length === 0 ? {} : data
    },
    toggleSpecialty(v) {
      if (this.selectedSpecialties.includes(v)) {
        this.selectedSpecialties = this.selectedSpecialties.filter(e => e !== v)
      } else {
        this.selectedSpecialties.push(v)
      }
    },
    async nextBtnClickHandler() {
      try {
        this.showFSLoader()

        await this.$axios.post(`${getBaseUrl()}/api/v2/${api.PRACTICE_LOCATION}/${this.user.practiceLocation.id}/registration-third-step`, {
          name: this.practiceName,
          phone: this.phone,
          specialties: this.selectedSpecialties,
          shippingAddress: { ...this.shippingAddress, unit: this.shippingSuite },
          billingAddress: this.billingIsSame ? null : { ...this.billingAddress, unit: this.billingSuite }
        })

        return true
      } catch (e) {
        console.error('onConfirm', e)

        this.externalError = e.response?.data?.error ?? 'Something went wrong'
        return false
      } finally {
        this.hideFSLoader()
      }
    }
  }
}
